<template>
	<div class="body">

		<div class="header">
			<div class="header-title" v-if="biData">{{biData.title}}</div>
			<img class="header-gif"
				src="https://syzsoss.oss-cn-chengdu.aliyuncs.com/202606/18120012-65592097738278147.gif" />
		</div>

		<div class="cnt">
			<div class="cnt-left">
				<div class="cnt-left-top">
					<div class="cnt-title">招聘岗位数据</div>
					<div class="cnt-table-row-title">
						<div class="table-row-index"></div>
						<div class="table-row-middle">岗位名称</div>
						<div class="table-row-right">公司</div>
					</div>
					<template v-if="newJobData">
						<div :class="['cnt-table-row-item', jobAnimIndex == index ? 'job-row-selected' : '']"
							v-for="(item, index) in newJobData.list" :key="item.id">
							<div class="table-row-index">{{item.index}}</div>
							<div class="table-row-middle">{{item.name}}</div>
							<div class="table-row-right">{{item.company_name}}</div>
						</div>
					</template>

				</div>

				<div class="cnt-left-bottom">
					<div class="degree-salary-ctr">
						<div class="cnt-title">学历分布</div>
						<div class="degreeChart" id="degreeChart"></div>
					</div>

					<div class="degree-salary-ctr">
						<div class="cnt-title">薪资分布</div>
						<div class="salaryChart" id="salaryChart"></div>
					</div>
				</div>

			</div>
			<div class="cnt-middle">
				<div class="top-num-ctr">
					<div v-for="item in topNumList" :key="item.name" class="top-num-item">
						<div class="top-title">{{item.name}}</div>
						<div class="top-value-ctr">
							<div class="top-value" :id="'num-' + item['id']">{{item.displayValue}}</div>
							<div class="top-unit">{{item.unit}}</div>
						</div>
					</div>
				</div>


				<div class="middle-bottom">
					<div class="middle-left">
						<div class="map-ctr">
							<div id="myChart" class="myChart"></div>
						</div>
						<div class="video-ctr">
							<video ref="videoRef" class="video" preload="auto"
								:key="videoList && videoList.length > videoIndex ? videoList[videoIndex]['url'] : ''"
								controls autoplay @ended="handleVideoEnded">
								<source
									:src="videoList && videoList.length > videoIndex ? videoList[videoIndex]['url'] : '' "
									type="video/mp4">
							</video>
						</div>
					</div>

					<div class="middle-right">
						<div class="major-job-rate-ctr">
							<div class="second-title" v-if="majorJobData">{{majorJobData.rateData.title}}</div>

							<div class="majorJobRateChart" id="majorJobRateChart"></div>
						</div>

						<div class="major-job-num-ctr">
							<div class="second-title" v-if="majorJobData">{{majorJobData.numData.title}}</div>

							<div class="majorJobNumChart" id="majorJobNumChart"></div>
						</div>
					</div>
				</div>


			</div>
			<div class="cnt-right">
				<div class="right-top">
					<div class="cnt-title" v-if="careerJobMonthData">{{careerJobMonthData.title}}</div>
					<div class="careerJobMonthChart" id="careerJobMonthChart"></div>
				</div>

				<div class="right-middle">
					<div class="cnt-title" v-if="careerJobQuarterData">{{careerJobQuarterData.title}}</div>
					<div class="careerJobQuarterChart" id="careerJobQuarterChart"></div>
				</div>

				<div class="right-bottom">
					<div class="cnt-title" v-if="careerJobYearData">{{careerJobYearData.title}}</div>
					<div class="careerJobYearChart" id="careerJobYearChart"></div>
				</div>

			</div>
		</div>


	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import {
		CountUp
	} from 'countup.js'
	import labelBgUrl from '@/assets/tip-bg.png';
	import {
		getData,
		getNewJobData,
		getCompanyData,
		getMajorJobData,
		getPartData
	} from "@/api/bi"

	import {
		convertList2Map
	} from "@/utils/util"

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	import chinaMap from '@/assets/mp_cq.json'

	var timer = null;
	let mapEchart = null;
	let degreeChart = null;
	let salaryChart = null;
	let majorJobRateChart = null;
	let majorJobNumChart = null;
	let careerJobMonthChart = null;
	let careerJobQuarterChart = null;
	let careerJobYearChart = null;

	let degreeSize = 1;
	let salarySize = 1;
	let majorJobRateSize = 1;
	let groupData = null;
	let isRefreshing = false;
	let areaMap = {};
	let baseWidth = 1920;

	export default {
		name: "Index",
		data() {
			return {
				newJobData: null,
				companyData: null,
				topNumList: null,
				
				companyAnimIndex: -1,
				jobAnimIndex: -1,
				majorAnimIndex: -1,
				areaSize: 1,

				mapTitle: '',
				newJobParams: {
					'newJobPageIndex': 1,
					'newJobPageSize': 8
				},
				companyParams: {
					'companyPageIndex': 1,
					'companyPageSize': 8
				},
				degreeData: null,
				salaryData: null,

				areaList: null,
				majorJobData: null,
				
				careerJobMonthData: null,
				careerJobQuarterData: null,
				careerJobYearData: null,
				
				biData: null,

				// 存储所有 CountUp 实例
				countUpInstances: {},
				// 统一配置
				commonOptions: {
					useEasing: true,
					useGrouping: true,
					separator: ',',
					decimal: '.',
					// 先快后慢的缓动函数
					easingFn: function(t, b, c, d) {
						const progress = t / d
						return c * (1 - Math.pow(1 - progress, 3)) + b
					}
				},
				videoList: [],
				videoIndex: 0,
				curWidth: 0
			}
		},
		created() {
			this.params = this.$route.query
		},

		mounted() {
			this.initPageData();
			this.curWidth = window.innerWidth;
			console.log('window.innerWidth', window.innerWidth)
			window.addEventListener('resize', this.handleResize);
		},

		// 组件销毁前清理
		beforeDestroy() {
			// 取消所有动画
			Object.values(this.countUpInstances).forEach(instance => {
				if (instance && instance.rAF) {
					cancelAnimationFrame(instance.rAF)
				}
			})
		},

		methods: {
			initPageData() {
				this.newJobParams.newJobPageIndex = 1;

				let params = {
					...this.newJobParams,
					...this.params,
				}

				isRefreshing = true;
				getData(params).then(res => {
					let realData = res.data;

					this.biData = realData.biData;
					this.newJobData = realData.newJobData;
					this.topNumList = realData.topNumList;
					this.majorJobData = realData.majorJobData;

					this.areaSize = realData.areaList.length;
					degreeSize = realData.degreeData.list.length ?? 1;
					salarySize = realData.salaryData.list.length ?? 1;

					this.mapTitle = realData.mapTitle;
					groupData = realData.groupData;

					this.careerJobMonthData = realData.careerJobMonthData;
					this.careerJobQuarterData = realData.careerJobQuarterData;
					this.careerJobYearData = realData.careerJobYearData;
					
					this.degreeData = realData.degreeData;
					this.salaryData = realData.salaryData;
					
					this.areaList = realData.areaList;

					let videoData = realData.videoData;

					let videoRefresh = this.isVideoNeedRefresh(videoData['list']);
					if (videoRefresh) {
						this.videoList = videoData['list'];
						this.videoIndex = 0;
					}
					
					this.initMapData()
					this.setDegreeChart()
					this.setSalaryChart()
					this.initMajorJobRateChart();
					this.initMajorJobNumChart();

					this.initCareerJobMonthChart();
					this.initCareerJobQuarterChart();
					this.initCareerJobYearChart();

					this.$nextTick(() => {
						this.delayInitNum();
					})

					groupData['partRefreshTime'] = Math.floor(Date.now() / 1000);
					groupData['pageRefreshTime'] = groupData['partRefreshTime'];

					isRefreshing = false;
					this.loopShow()
				}).catch(e => {
					isRefreshing = false;
				})
			},

			// 计算缩放系数
			scaleRatio() {
				let currentWidth = window.innerWidth;
				let rate = currentWidth / baseWidth;
				// console.log('scaleRatio rate', rate)
				rate = Math.max(rate, 0.6)
				rate = Math.min(rate, 1.5);
				// console.log('scaleRatio after rate', rate)
				// 限制最小缩放比例，避免太小
				return rate;
			},

			scaleSize(size) {
				return Math.round(size * this.scaleRatio());
			},


			handleResize() {
				if(degreeChart){
					this.setDegreeChart(true);
					degreeChart.resize();
				}
				
				if(salaryChart){
					this.setSalaryChart(true);
					salaryChart.resize();
				}
				
				if(mapEchart){
					this.initMapData();
					mapEchart.resize();
				}
				
				if(majorJobRateChart){
					this.initMajorJobRateChart(true);
					majorJobRateChart.resize();
				}
				
				if(majorJobNumChart){
					this.initMajorJobNumChart();
					majorJobNumChart.resize();
				}
				
				if(careerJobMonthChart){
					this.initCareerJobMonthChart();
					careerJobMonthChart.resize();
				}
				
				if(careerJobQuarterChart){
					this.initCareerJobQuarterChart();
					careerJobQuarterChart.resize();
				}
				
				if(careerJobYearChart){
					this.initCareerJobYearChart();
					careerJobYearChart.resize();
				}
			},

			handleVideoEnded(event) {
				let size = this.videoList.length;
				this.videoIndex = (this.videoIndex + 1) % size;
				console.log('handleVideoEnded this.videoIndex', this.videoIndex)

				if (size == 1) {
					let video = this.$refs.videoRef
					if (!video) return
					video.play()
				}

			},

			delayInitNum() {
				let that = this;
				that.initOrUpdateCountUps();
				setTimeout(function() {
					that.initOrUpdateCountUps();
				}, 2)
			},

			// 初始化或更新所有 CountUp 实例
			initOrUpdateCountUps() {
				this.topNumList.forEach(stat => {
					const elementId = `num-${stat.id}`
					const element = document.getElementById(elementId)

					if (!element) {
						console.warn(`元素 ${elementId} 未找到`)
						return
					}

					// 如果实例已存在，直接更新
					if (this.countUpInstances[stat.id]) {
						const instance = this.countUpInstances[stat.id]

						// 重置到起始值（0）
						instance.reset()

						// 重新设置起始值为 0
						instance.startVal = 0

						// 更新目标值
						instance.update(stat.value)

						// 更新动画完成回调
						instance.callback = () => {
							stat.displayValue = stat.value
						}
					} else {
						// 创建新实例
						const instance = new CountUp(
							elementId,
							0, // 起始值从 0 开始
							stat.value, // 目标值
							0, // 小数位数
							2.5, // 动画时长（秒）
							{
								...this.commonOptions,
								prefix: stat.prefix || '',
								suffix: stat.suffix || ''
							}
						)

						if (instance.error) {
							console.error(`CountUp 初始化错误 (${stat.id}):`, instance.error)
							return
						}

						// 保存实例
						this.countUpInstances[stat.id] = instance

						// console.log('elementId', elementId, 'stat.value', stat.value)
						// 启动动画
						instance.start(() => {
							// console.log('elementId', elementId, 'done---------stat.value', stat.value)
							// 动画完成回调
							stat.displayValue = stat.value
						})
					}
				})
			},

			initMapData() {
				
				let option = this.getMapConfig();

				areaMap = convertList2Map(this.areaList, 'name')

				this.$echarts.registerMap('china', chinaMap);

				if (!mapEchart) {
					mapEchart = this.$echarts.init(document.getElementById('myChart'));
				}

				option.series[0].data = this.areaList;

				mapEchart.setOption(option, true);
				mapEchart.currentIndex = -1;
			},

			loopShow() {
				clearTimeout(timer);
				let that = this;
				timer = setInterval(function() {
					if (!isRefreshing) {
						that.animNewJob();
						that.animMap();
						that.animMajorJobRate();
						that.animDegree();
						that.animSalary();
						that.checkAllPartRefresh();
					}

				}, 2000);
			},

			checkAllPartRefresh() {
				let curTime = Math.floor(Date.now() / 1000);
				let delta = curTime - groupData['pageRefreshTime'];
				let index = groupData['index'];

				let pageInterval = groupData['list'][index]['page_interval'];

				// console.log('pageInterval', pageInterval, 'delta', delta)

				if (pageInterval > 0 && groupData['list'].length > 1 && delta >= pageInterval) {
					let nextIndex = (index + 1) % groupData['list'].length;
					this.params['group_id'] = groupData['list'][nextIndex]['id'];
					this.newJobParams['group_id'] = this.params['group_id'];
					// console.log('page refresh nextIndex', nextIndex, 'id', this.params)
					this.initPageData();
					return;
				}

				delta = curTime - groupData['partRefreshTime'];
				let interval = groupData['list'][index]['part_interval'];
				// console.log('partInterval', interval, 'delta', delta)

				if (interval > 0 && delta >= interval) {
					console.log('part refresh')
					isRefreshing = true;
					let params = this.params;
					params['group_id'] = groupData['list'][index]['id'];

					getPartData(params).then(res => {
						let realData = res.data;

						this.topNumList = realData.topNumList;
						this.majorJobData = realData.majorJobData;

						this.areaSize = realData.areaList.length;
						degreeSize = realData.degreeData.list.length ?? 1;
						salarySize = realData.salaryData.list.length ?? 1;

						this.careerJobMonthData = realData.careerJobMonthData;
						this.careerJobQuarterData = realData.careerJobQuarterData;
						this.careerJobYearData = realData.careerJobYearData;
						
						this.degreeData = realData.degreeData;
						this.salaryData = realData.salaryData;
						
						this.areaList = realData.areaList;

						this.initMapData()
						this.setDegreeChart()
						this.setSalaryChart()
						this.initMajorJobRateChart();
						this.initMajorJobNumChart();

						this.initCareerJobMonthChart();
						this.initCareerJobQuarterChart();
						this.initCareerJobYearChart();

						groupData['partRefreshTime'] = Math.floor(Date.now() / 1000);
						isRefreshing = false;
					}).catch(e => {
						isRefreshing = false;
					})
				}
			},

			isVideoNeedRefresh(newList) {
				console.log('this.videoList', this.videoList)
				console.log('newList', newList)

				if (this.videoList.length != newList.length) {
					return true;
				}

				let map = convertList2Map(this.videoList, 'url');

				let size = newList.length;

				for (let i = 0; i < size; i++) {
					let old = map[newList[i]['url']];

					if (!old) {
						return true;
					}
				}

				return false;
			},

			animDegree() {
				degreeChart.dispatchAction({
					type: "downplay",
					seriesIndex: 0,
					dataIndex: degreeChart.currentIndex
				});

				if (degreeChart.currentIndex == -1) {
					degreeChart.currentIndex = 0;
				} else {
					degreeChart.currentIndex = (degreeChart.currentIndex + 1) % degreeSize;
				}

				degreeChart.dispatchAction({
					type: "highlight",
					seriesIndex: 0,
					dataIndex: degreeChart.currentIndex
				});
			},

			animMajorJobRate() {
				majorJobRateChart.dispatchAction({
					type: "downplay",
					seriesIndex: 0,
					dataIndex: majorJobRateChart.currentIndex
				});

				if (majorJobRateChart.currentIndex == -1) {
					majorJobRateChart.currentIndex = 0;
				} else {
					majorJobRateChart.currentIndex = (majorJobRateChart.currentIndex + 1) % majorJobRateSize;
				}

				majorJobRateChart.dispatchAction({
					type: "highlight",
					seriesIndex: 0,
					dataIndex: majorJobRateChart.currentIndex
				});
			},


			animSalary() {
				salaryChart.dispatchAction({
					type: "downplay",
					seriesIndex: 0,
					dataIndex: salaryChart.currentIndex
				});

				if (salaryChart.currentIndex == -1) {
					salaryChart.currentIndex = 0;
				} else {
					salaryChart.currentIndex = (salaryChart.currentIndex + 1) % salarySize;
				}

				salaryChart.dispatchAction({
					type: "highlight",
					seriesIndex: 0,
					dataIndex: salaryChart.currentIndex
				});
			},

			animMap() {
				mapEchart.dispatchAction({
					type: "downplay",
					seriesIndex: 0,
					dataIndex: mapEchart.currentIndex
				});

				if (mapEchart.currentIndex == -1) {
					mapEchart.currentIndex = 0;
				} else {
					mapEchart.currentIndex = (mapEchart.currentIndex + 1) % this.areaSize;
				}

				mapEchart.dispatchAction({
					type: "highlight",
					seriesIndex: 0,
					dataIndex: mapEchart.currentIndex
				});
			},

			animNewJob() {
				let size = this.newJobData.list.length ?? 0;

				if (size == 0) {
					return;
				}

				if (this.jobAnimIndex == -1) {
					this.jobAnimIndex = 0;
				} else {
					this.jobAnimIndex += 1;

					if (this.jobAnimIndex >= size) {
						this.refreshNewJobData();
					} else {
						this.jobAnimIndex = this.jobAnimIndex % size;
					}
				}
			},

			refreshNewJobData() {
				if (this.newJobData.pageData.hasMore == 1) {
					this.newJobParams.newJobPageIndex += 1;
				} else {
					this.newJobParams.newJobPageIndex = 1;
				}

				let index = groupData['index'];
				this.newJobParams['group_id'] = groupData['list'][index]['id'];
				getNewJobData(this.newJobParams).then(res => {
					let realData = res.data;
					this.newJobData = realData.newJobData;
					this.jobAnimIndex = 0;
				});
			},

			animCompany() {
				let size = this.companyData.list.length ?? 0;

				if (size == 0) {
					return;
				}

				if (this.companyAnimIndex == -1) {
					this.companyAnimIndex = 0;
				} else {
					this.companyAnimIndex += 1;

					if (this.companyAnimIndex >= size) {
						this.refreshCompanyData();
					} else {
						this.companyAnimIndex = this.companyAnimIndex % size;
					}
				}
			},

			refreshCompanyData() {
				if (this.companyData.pageData.hasMore == 1) {
					this.companyParams.companyPageIndex += 1;
				} else {
					this.companyParams.companyPageIndex = 1;
				}

				getCompanyData(this.companyParams).then(res => {
					let realData = res.data;
					this.companyData = realData.companyData;
					this.companyAnimIndex = 0;
				});
			},

			initCareerJobMonthChart() {
				if(!(this.careerJobMonthData && this.careerJobMonthData.list && this.careerJobMonthData.list.length > 0)){
					return;
				}

				if (!careerJobMonthChart) {
					careerJobMonthChart = this.$echarts.init(document.getElementById('careerJobMonthChart'));
				}

				let option = this.getCareerJobOption(this.careerJobMonthData.list);

				// 应用配置
				careerJobMonthChart.setOption(option, true);
			},

			initCareerJobQuarterChart() {
				if(!(this.careerJobQuarterData && this.careerJobQuarterData.list && this.careerJobQuarterData.list.length > 0)){
					return;
				}
				
				if (!careerJobQuarterChart) {
					careerJobQuarterChart = this.$echarts.init(document.getElementById('careerJobQuarterChart'));
				}

				let option = this.getCareerJobOption(this.careerJobQuarterData.list);

				// 应用配置
				careerJobQuarterChart.setOption(option, true);
			},

			initCareerJobYearChart() {
				if(!(this.careerJobYearData && this.careerJobYearData.list && this.careerJobYearData.list.length > 0)){
					return;
				}
				
				if (!careerJobYearChart) {
					careerJobYearChart = this.$echarts.init(document.getElementById('careerJobYearChart'));
				}

				let option = this.getCareerJobOption(this.careerJobYearData.list);

				// 应用配置
				careerJobYearChart.setOption(option, true);
			},

			getCareerJobOption(numList) {
				let nameList = [];
				let valueList = [];

				let angle = 20;

				if (numList.length <= 4) {
					angle = 0;
				}


				numList.forEach(function(e) {
					nameList.push(e['name']);
					valueList.push(e['value'])
				}, this);

				let max = Math.max(...valueList);

				let interval = Math.ceil(max / 3);
				let option = {
					grid: {
						top: 50,
						bottom: "20%"
					},
					xAxis: {
						data: nameList,
						axisLine: {
							show: true,
							lineStyle: {
								color: "#ffffff"
							}
						},
						axisTick: {
							show: true
						},
						axisLabel: {
							// 右边的数值标签会跟随轴，但我们会在 series 里单独控制更精确的显示
							show: true,
							color: '#ffffff',
							fontSize: this.scaleSize(12),  
							rotate: angle, // 旋转角度，30-45度最佳
							interval: 0, // 强制显示所有标签

						},
					},
					yAxis: [{
						name: "需求人数",
						axisLine: {
							show: true,
							fontSize: this.scaleSize(12),  
							lineStyle: {
								color: "#ffffff"
							}
						},
						axisLabel: {
							// 右边的数值标签会跟随轴，但我们会在 series 里单独控制更精确的显示
							show: true,
							formatter: '{value} 人', // 显示单位
							color: '#ffffff'
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: true
						},
						interval: interval,
						min: 0,
						max: max,
						position: "left"
					}],
					series: [{
						name: "需求人数",
						type: "bar",
						barWidth: "40%",
						barGap: 5,
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: "#00fecc"
										},
										{
											offset: 0.8,
											color: "#2690cf"
										}
									],
									false
								)
							}
						},
						data: valueList
					}]
				};

				return option;
			},

			setDegreeChart(isAdjusting = false) {
				if (!degreeChart) {
					degreeChart = this.$echarts.init(document.getElementById('degreeChart'));
				}

				let option = this.getDegreeOption(this.degreeData.list);
				degreeChart.setOption(option, true)
				if(!isAdjusting){
					degreeChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,
						dataIndex: degreeChart.currentIndex
					});
					degreeChart.currentIndex = 1;
				}
			},

			setSalaryChart(isAdjusting = false) {
				if (!salaryChart) {
					salaryChart = this.$echarts.init(document.getElementById('salaryChart'));
				}

				let option = this.getSalaryOption(this.salaryData.list);
				salaryChart.setOption(option, true)
				if(!isAdjusting){
					salaryChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,
						dataIndex: salaryChart.currentIndex
					});
					salaryChart.currentIndex = 1;
				}
			},

			buildParams() {
				let params = this.params;

				return params;
			},


			initMajorJobRateChart(isAdjusting = false) {
				if(!(this.majorJobData && this.majorJobData.rateData && this.majorJobData.rateData.list && this.majorJobData.rateData.list.length > 0)){
					return;
				}
				
				if (!majorJobRateChart) {
					majorJobRateChart = this.$echarts.init(document.getElementById('majorJobRateChart'));
				}
				majorJobRateSize = this.majorJobData.rateData.list.length;
				let option = this.getMajorJobRateChartOption(this.majorJobData.rateData.list);
				// 应用配置
				majorJobRateChart.setOption(option, true);
				if(!isAdjusting){
					majorJobRateChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,
						dataIndex: majorJobRateChart.currentIndex
					});
					majorJobRateChart.currentIndex = -1;
				}
		
			},

			initMajorJobNumChart() {
				if(!(this.majorJobData && this.majorJobData.numData && this.majorJobData.numData.list && this.majorJobData.numData.list.length > 0)){
					return;
				}
				
				if (!this.majorJobNumChart) {
					this.majorJobNumChart = this.$echarts.init(document.getElementById('majorJobNumChart'));
				}

				let option = this.getMajorJobNumChartOption(this.majorJobData.numData.list);

				// 应用配置
				this.majorJobNumChart.setOption(option, true);
			},

			getMajorJobNumChartOption(numList) {

				let nameList = [];
				let valueList = [];

				numList.forEach(function(e) {
					nameList.push(e['name']);
					valueList.push(e['value'])
				}, this);
				
				let num = numList.length;
				
				let angle = 0;
				
				if (num >= 4){
					angle = 20;
				}

				let max = Math.max(...valueList);
				let interval = Math.ceil(max / 6);

				let option = {
					grid: {
						top: 50,
						bottom: "20%"
					},
					xAxis: {
						data: nameList,
						axisLine: {
							show: true,
							lineStyle: {
								color: "#ffffff",
								fontSize: this.scaleSize(12)
							}
						},
						axisTick: {
							show: true
						},
						axisLabel: {
							// 右边的数值标签会跟随轴，但我们会在 series 里单独控制更精确的显示
							show: true,
							color: '#ffffff',
							rotate: angle, // 旋转角度，30-45度最佳
							interval: 0, // 强制显示所有标签,
							fontSize: this.scaleSize(12)

						},
					},
					yAxis: [{
						name: "需求人数",
						axisLine: {
							show: true,
							lineStyle: {
								color: "#ffffff",
								fontSize: this.scaleSize(12)
							}
						},
						axisLabel: {
							// 右边的数值标签会跟随轴，但我们会在 series 里单独控制更精确的显示
							show: true,
							formatter: '{value} 人', // 显示单位
							color: '#ffffff',
							fontSize: this.scaleSize(12)
						},
						splitLine: {
							show: false
						},
						axisTick: {
							show: true
						},
						interval: interval,
						min: 0,
						max: max,
						position: "left"
					}],
					series: [{
						name: "需求人数",
						type: "bar",
						barWidth: "40%",
						barGap: 5,
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: "#00fecc"
										},
										{
											offset: 0.8,
											color: "#2690cf"
										}
									],
									false
								)
							}
						},
						data: valueList
					}]
				};

				return option;
			},


			getMajorJobRateChartOption(rateList) {
				let nameList = [];
				let colorList = [];

				rateList.forEach(function(element) {
					nameList.push(element['name'])
					colorList.push(element['color'])
				}, this);

				var pieRich = {
					big: {
						fontSize: this.scaleSize(26),
						lineHeight: this.scaleSize(30),
						fontFamily: 'Rubik'
					},
					small: {
						fontSize: this.scaleSize(22)
					},
				}

				let option = {
					legend: {
						x: 'left',
						top: '65%',
						left: 'center',
						itemWidth: this.scaleSize(50),
						itemHeight: this.scaleSize(15),
						fontSize: this.scaleSize(15),
						textStyle: {
							color: '#fff'
						},
						data: nameList
					},
					series: [{
						name: '销售占比',
						type: 'pie',
						radius: ['40%', '50%'],
						hoverOffset: 5,
						center: ['50%', '35%'],
						avoidLabelOverlap: false,
						color: colorList,
						label: {
							normal: {
								show: false,
								position: 'center'
							},
							emphasis: {
								show: true,
								color: '#fff',
								scale: true, // 开启缩放
								scaleSize: 30, // 缩放大小（单位：像素），即高亮时向外扩展的尺寸
								formatter: function(params, ticket, callback) {
									// console.log
									return '{big|' + params.value + '}{small|%}\n{small|' + params.name +
										'}';
								},
								// '{a|这段文本采用样式a}'
								rich: pieRich
							}
						},
						emphasis: {
							// 高亮配置
							scale: true, // 开启缩放
							scaleSize: 15, // 缩放大小（单位：像素），即高亮时向外扩展的尺寸
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							label: {
								show: true,
								fontWeight: 'bold',
								fontSize: 14
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: rateList
					}]
				};

				return option;
			},


			getSalaryOption(list) {

				let nameList = [];
				let colorList = []

				list.forEach(function(element) {
					nameList.push(element['name']);
					colorList.push(element['color'])
				}, this);

				var pieRich = {
					big: {
						fontSize: this.scaleSize(30),
						lineHeight: this.scaleSize(30),
						fontFamily: 'Rubik'
					},
					small: {
						fontSize: this.scaleSize(28)
					},
				}

				let option = {
					legend: {
						x: 'left',
						top: '70%',
						left: 'center',
						itemWidth: this.scaleSize(20),
						itemHeight: this.scaleSize(10),
						fontSize: this.scaleSize(15),
						textStyle: {
							color: '#fff'
						},
						data: nameList
					},
					series: [{
						name: '销售占比',
						type: 'pie',
						radius: ['65%', '75%'],
						hoverOffset: 5,
						center: ['50%', '35%'],
						avoidLabelOverlap: false,
						color: colorList,
						label: {
							normal: {
								show: false,
								position: 'center'
							},
							emphasis: {
								show: true,
								color: '#fff',
								scale: true, // 开启缩放
								scaleSize: 30, // 缩放大小（单位：像素），即高亮时向外扩展的尺寸
								formatter: function(params, ticket, callback) {
									// console.log
									return '{big|' + params.value + '}{small|%}\n{small|' + params.name +
										'}';
								},
								// '{a|这段文本采用样式a}'
								rich: pieRich
							}
						},
						emphasis: {
							// 高亮配置
							scale: true, // 开启缩放
							scaleSize: 15, // 缩放大小（单位：像素），即高亮时向外扩展的尺寸
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							label: {
								show: true,
								fontWeight: 'bold',
								fontSize: 14
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: list
					}]
				};

				return option;
			},

			getDegreeOption(degreeList) {

				let nameList = [];
				let colorList = [];

				degreeList.forEach(function(element) {
					nameList.push(element['name'])
					colorList.push(element['color'])
				}, this);

				var pieRich = {
					big: {
						fontSize: this.scaleSize(30),
						lineHeight: this.scaleSize(30),
						fontFamily: 'Rubik'
					},
					small: {
						fontSize: this.scaleSize(28)
					},
				}

				let option = {
					legend: {
						x: 'left',
						top: '70%',
						left: 'center',
						itemWidth: this.scaleSize(20),
						itemHeight: this.scaleSize(10),
						fontSize: this.scaleSize(15),
						textStyle: {
							color: '#fff'
						},
						data: nameList
					},
					series: [{
						name: '销售占比',
						type: 'pie',
						radius: ['65%', '75%'],
						hoverOffset: 5,
						center: ['50%', '35%'],
						avoidLabelOverlap: false,
						color: colorList,
						label: {
							normal: {
								show: false,
								position: 'center'
							},
							emphasis: {
								show: true,
								color: '#fff',
								scale: true, // 开启缩放
								scaleSize: 30, // 缩放大小（单位：像素），即高亮时向外扩展的尺寸
								formatter: function(params, ticket, callback) {
									// console.log
									return '{big|' + params.value + '}{small|%}\n{small|' + params.name +
										'}';
								},
								// '{a|这段文本采用样式a}'
								rich: pieRich
							}
						},
						emphasis: {
							// 高亮配置
							scale: true, // 开启缩放
							scaleSize: 15, // 缩放大小（单位：像素），即高亮时向外扩展的尺寸
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							label: {
								show: true,
								fontWeight: 'bold',
								fontSize: 14
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: degreeList
					}]
				};

				return option;
			},

			getMapConfig() {

				let zoom = 4.5;
				let centor = [108, 29.9];

				var rich = {
					a: {
						color: '#fff',
						fontSize: 18,
						align: 'left',
						verticalAlign: 'middle',
						padding: [50, 0, 0, 25] // [上, 右, 下, 左]
					},
					b: {
						color: '#fff',
						fontSize: 16,
						padding: [50, 0, 0, 25],
						verticalAlign: 'middle',
					},
					c: {
						color: '#fff',
						fontSize: 20,
						padding: [0, 0, 10, 110],
						align: 'middle'

					},

				}

				let that = this;

				var option = {
					geo: {
						map: "china",
						label: {
							emphasis: {
								show: false
							}
						},
						roam: false,
						layoutCenter: ["50%", "55%"],
						layoutSize: "110%",
						zoom: zoom, // 增加缩放比例
						center: centor, // 设置地图中心点经纬度（以重庆为例）
						regions: [{
								name: '渝中区',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '大渡口区',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '江北区',
								itemStyle: {
									areaColor: '#27E9FD',
									opacity: 0.2
								}

							},
							{
								name: '沙坪坝区',
								itemStyle: {
									areaColor: '#0E7DEB',
									opacity: 0.2
								}
							},
							{
								name: '九龙坡区',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '南岸区',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '北碚区',
								itemStyle: {
									areaColor: '#20CAF8',
									opacity: 0.2
								}
							},
							{
								name: '綦江区',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '大足区',
								itemStyle: {
									areaColor: '#17A3F1',
									opacity: 0.2
								}
							},
							{
								name: '渝北区',
								itemStyle: {
									areaColor: '#0554E4',
									opacity: 0.2
								}
							},
							{
								name: '巴南区',
								itemStyle: {
									areaColor: '#27E8FD',
									opacity: 0.2
								}
							},
							{
								name: '万州区',
								itemStyle: {
									areaColor: '#4BFFFF',
									opacity: 0.2
								}
							},
							{
								name: '黔江区',
								itemStyle: {
									areaColor: '#17A3F1',
									opacity: 0.2
								}
							},
							{
								name: '长寿区',
								itemStyle: {
									areaColor: '#00b6f6',
									opacity: 0.2
								}
							},
							{
								name: '江津区',
								itemStyle: {
									areaColor: '#00b6f6',
									opacity: 0.2
								}
							},
							{
								name: '合川区',
								itemStyle: {
									areaColor: '#01a4f1',
									opacity: 0.2
								}
							},
							{
								name: '永川区',
								itemStyle: {
									areaColor: '#005ce5',
									opacity: 0.2
								}
							},
							{
								name: '南川区',
								itemStyle: {
									areaColor: '#0088ec',
									opacity: 0.2
								}
							},
							{
								name: '璧山区',
								itemStyle: {
									areaColor: '#0042df',
									opacity: 0.2
								}
							},
							{
								name: '铜梁区',
								itemStyle: {
									areaColor: '#01d0fa',
									opacity: 0.2
								}
							},
							{
								name: '潼南区',
								itemStyle: {
									areaColor: '#00ccf7',
									opacity: 0.2
								}
							},
							{
								name: '荣昌区',
								itemStyle: {
									areaColor: '#01b0f3',
									opacity: 0.2
								}
							},
							{
								name: '开州区',
								itemStyle: {
									areaColor: '#0051e1',
									opacity: 0.2
								}
							},
							{
								name: '梁平区',
								itemStyle: {
									areaColor: '#0158e3',
									opacity: 0.2
								}
							},
							{
								name: '武隆区',
								itemStyle: {
									areaColor: '#f199ea',
									opacity: 0.2
								}
							},
							{
								name: '涪陵区',
								itemStyle: {
									areaColor: '#00d9fc',
									opacity: 0.2
								}
							},
							{
								name: '城口县',
								itemStyle: {
									areaColor: '#005ae4',
									opacity: 0.2
								}
							},
							{
								name: '丰都县',
								itemStyle: {
									areaColor: '#01e9fd',
									opacity: 0.2
								}
							},
							{
								name: '垫江县',
								itemStyle: {
									areaColor: '#0069e8',
									opacity: 0.2
								}
							},
							{
								name: '忠县',
								itemStyle: {
									areaColor: '#01b0f3',
									opacity: 0.2
								}
							},
							{
								name: '云阳县',
								itemStyle: {
									areaColor: '#00f0ff',
									opacity: 0.2
								}
							},
							{
								name: '奉节县',
								itemStyle: {
									areaColor: '#0067e7',
									opacity: 0.2
								}
							},
							{
								name: '巫山县',
								itemStyle: {
									areaColor: '#00dafa',
									opacity: 0.2
								}
							},
							{
								name: '巫溪县',
								itemStyle: {
									areaColor: '#00dafa',
									opacity: 0.2
								}
							},
							{
								name: '石柱土家族自治县',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '秀山土家族苗族自治县',
								itemStyle: {
									areaColor: '#034DE4',
									opacity: 0.2
								}
							},
							{
								name: '酉阳土家族苗族自治县',
								itemStyle: {
									areaColor: '#27E9FD',
									opacity: 0.2
								}

							},
							{
								name: '彭水苗族土家族自治县',
								itemStyle: {
									areaColor: '#0E7DEB',
									opacity: 0.2
								}
							}
						]
					},
					series: [{
							name: "中国",
							type: "map",
							mapType: "china",
							layoutCenter: ["50%", "55%"],
							layoutSize: "110%",
							zoom: zoom, // 增加缩放比例
							center: centor, // 设置地图中心点经纬度（以重庆为例）
							label: {
								width: 270,
								height: 120,
								backgroundColor: {
									image: labelBgUrl
								},
								emphasis: {
									show: true,
									color: "#fff",
									formatter: function(params) {
										var tt = that.formatterShow(params)
										return tt;
									}
								},
								rich: rich,
								// show: true
							},
							itemStyle: {
								normal: {
									opacity: 0.1
								},
								emphasis: {
									opacity: 1,
									borderWidth: 2,
									borderColor: '#fff'
								}
							}
						},

					]
				};

				return option;
			},

			formatterShow(params) {
				var data = params.data;

				var numArr = [];
				var numData = [];
				var formatterStr = '';
				var paramsData = [
					"园区数量：" + data.uploadcnt + '个',
					"岗位数量：" + data.uploadpzs + '个',
					"企业数量：" + data.xsmy + '个',
				]

				if (data.uploadcnt != undefined && data.uploadcnt != '') {
					numArr.push(0)
				}
				if (data.uploadpzs != undefined && data.uploadpzs != '') {
					numArr.push(1)
				}
				if (data.xsmy != undefined && data.xsmy != '') {
					numArr.push(2)
				}

				for (var i = 0; i < numArr.length; i++) {
					numData.push(paramsData[numArr[i]])
				}

				let name = params.name;
				if (areaMap[name] && areaMap[name]['showName']) {
					name = areaMap[name]['showName'];
				}

				if (numData.length == 1) {
					formatterStr = '{a|' + name + '}' +
						'{b|' + numData[0] + '}'
				} else if (numData.length == 2) {
					formatterStr = '{a|' + name + '}' + '\n' +
						'{b|' + numData[0] + '}' + '\n' +
						'{c|' + numData[1] + '}'
				} else if (numData.length == 3) {
					formatterStr = '{a|' + name + '}' + '\n' +
						'{b|' + numData[0] + '}' + '\n' +
						'{c|' + numData[1] + '}' + '\n' +
						'{d|' + numData[2] + '}' + '\n'
				} else if (numData.length == 4) {
					formatterStr = '{a|' + name + '}' + '\n' +
						'{b|' + numData[0] + '}' + '\n' +
						'{c|' + numData[1] + '}' + '\n' +
						'{d|' + numData[2] + '}' + '\n' +
						'{e|' + numData[3] + '}' + '\n'
				}

				// console.log('formatterStr', formatterStr)
				return formatterStr
			}
		},
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "index.scss";
</style>